
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
} = require('./runtime/index-browser')


const Prisma = {}

exports.Prisma = Prisma

/**
 * Prisma Client JS version: 4.16.2
 * Query Engine version: 4bc8b6e1b66cb932731fb1bdbbc550d1e010de81
 */
Prisma.prismaVersion = {
  client: "4.16.2",
  engine: "4bc8b6e1b66cb932731fb1bdbbc550d1e010de81"
}

Prisma.PrismaClientKnownRequestError = () => {
  throw new Error(`PrismaClientKnownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  throw new Error(`PrismaClientUnknownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientRustPanicError = () => {
  throw new Error(`PrismaClientRustPanicError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientInitializationError = () => {
  throw new Error(`PrismaClientInitializationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientValidationError = () => {
  throw new Error(`PrismaClientValidationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.NotFoundError = () => {
  throw new Error(`NotFoundError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  throw new Error(`sqltag is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.empty = () => {
  throw new Error(`empty is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.join = () => {
  throw new Error(`join is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.raw = () => {
  throw new Error(`raw is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  throw new Error(`Extensions.getExtensionContext is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.defineExtension = () => {
  throw new Error(`Extensions.defineExtension is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}

/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.DeletedItemScalarFieldEnum = {
  createdAt: 'createdAt',
  id: 'id',
  rowData: 'rowData',
  tableName: 'tableName'
};

exports.Prisma.UserScalarFieldEnum = {
  auth0Id: 'auth0Id',
  createdAt: 'createdAt',
  email: 'email',
  hasCrossOrgSearchSharingPermission: 'hasCrossOrgSearchSharingPermission',
  id: 'id',
  name: 'name',
  organizationId: 'organizationId',
  timezone: 'timezone',
  updatedAt: 'updatedAt'
};

exports.Prisma.OrganizationScalarFieldEnum = {
  auth0Id: 'auth0Id',
  createdAt: 'createdAt',
  id: 'id',
  name: 'name',
  updatedAt: 'updatedAt',
  featureMediaCategoryIsEnabled: 'featureMediaCategoryIsEnabled'
};

exports.Prisma.SavedSearchScalarFieldEnum = {
  createdAt: 'createdAt',
  groupBlockId: 'groupBlockId',
  id: 'id',
  name: 'name',
  updatedAt: 'updatedAt',
  userId: 'userId',
  filterId: 'filterId'
};

exports.Prisma.SavedSearchUserLogScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  savedSearchId: 'savedSearchId'
};

exports.Prisma.GroupBlockScalarFieldEnum = {
  booleanMode: 'booleanMode',
  exclude: 'exclude',
  id: 'id',
  parentGroupId: 'parentGroupId'
};

exports.Prisma.TextBlockScalarFieldEnum = {
  exclude: 'exclude',
  groupId: 'groupId',
  id: 'id',
  value: 'value'
};

exports.Prisma.UsernameBlockScalarFieldEnum = {
  exclude: 'exclude',
  groupId: 'groupId',
  id: 'id',
  value: 'value'
};

exports.Prisma.StartsWithBlockScalarFieldEnum = {
  exclude: 'exclude',
  groupId: 'groupId',
  id: 'id',
  value: 'value'
};

exports.Prisma.SavedSearchBlockScalarFieldEnum = {
  exclude: 'exclude',
  groupId: 'groupId',
  id: 'id',
  savedSearchId: 'savedSearchId'
};

exports.Prisma.SearchLogScalarFieldEnum = {
  createdAt: 'createdAt',
  id: 'id',
  returnedRowCount: 'returnedRowCount',
  savedSearchId: 'savedSearchId',
  searchTerms: 'searchTerms',
  searchTree: 'searchTree',
  subscriptionId: 'subscriptionId',
  userId: 'userId'
};

exports.Prisma.UsernameSearchLogScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  username: 'username',
  platform: 'platform',
  count: 'count',
  userId: 'userId'
};

exports.Prisma.SavedSearchSharedUsersScalarFieldEnum = {
  id: 'id',
  permission: 'permission',
  savedSearchId: 'savedSearchId',
  userId: 'userId'
};

exports.Prisma.SavedSearchSharedOrgsScalarFieldEnum = {
  id: 'id',
  organizationId: 'organizationId',
  permission: 'permission',
  savedSearchId: 'savedSearchId'
};

exports.Prisma.SavedSearchNarrativeScalarFieldEnum = {
  id: 'id',
  narrative: 'narrative',
  savedSearchId: 'savedSearchId'
};

exports.Prisma.SavedPostScalarFieldEnum = {
  createdAt: 'createdAt',
  id: 'id',
  mysqlPostId: 'mysqlPostId',
  savedSearchId: 'savedSearchId',
  userId: 'userId'
};

exports.Prisma.QuickShareEmailAddressesScalarFieldEnum = {
  emailAddress: 'emailAddress',
  id: 'id',
  userId: 'userId'
};

exports.Prisma.SavedSearchSubscriptionScalarFieldEnum = {
  createdAt: 'createdAt',
  frequency: 'frequency',
  id: 'id',
  includeResults: 'includeResults',
  lastMaxInsertedAt: 'lastMaxInsertedAt',
  savedSearchId: 'savedSearchId',
  sendToEmails: 'sendToEmails',
  updatedAt: 'updatedAt',
  userId: 'userId',
  filterId: 'filterId'
};

exports.Prisma.ReportedPostScalarFieldEnum = {
  contentType: 'contentType',
  createdAt: 'createdAt',
  id: 'id',
  postId: 'postId',
  reviewedBy: 'reviewedBy',
  reviewStatus: 'reviewStatus',
  updatedAt: 'updatedAt',
  userId: 'userId'
};

exports.Prisma.ApiPlanScalarFieldEnum = {
  createdAt: 'createdAt',
  endpointRequestsPerMinute: 'endpointRequestsPerMinute',
  id: 'id',
  maxRowsPerRequest: 'maxRowsPerRequest',
  maxUsernamesMonitored: 'maxUsernamesMonitored',
  name: 'name',
  updatedAt: 'updatedAt',
  organizationId: 'organizationId',
  isActive: 'isActive',
  authKey: 'authKey',
  package: 'package'
};

exports.Prisma.ApiCustomerScalarFieldEnum = {
  apiPlanId: 'apiPlanId',
  authKey: 'authKey',
  createdAt: 'createdAt',
  id: 'id',
  isActive: 'isActive',
  name: 'name',
  updatedAt: 'updatedAt',
  package: 'package'
};

exports.Prisma.ApiRequestLogScalarFieldEnum = {
  apiCustomerId: 'apiCustomerId',
  apiPlanId: 'apiPlanId',
  createdAt: 'createdAt',
  endPoint: 'endPoint',
  requestTimeMs: 'requestTimeMs',
  id: 'id'
};

exports.Prisma.PlatformScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  isCurrentlyCollected: 'isCurrentlyCollected',
  platformPackageId: 'platformPackageId',
  elasticSearchIndexName: 'elasticSearchIndexName',
  prefix: 'prefix'
};

exports.Prisma.PlatformPackageScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name'
};

exports.Prisma.OrganizationPlatformPackageScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  platformPackageId: 'platformPackageId',
  organizationId: 'organizationId'
};

exports.Prisma.OrganizationPlatformScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  platformId: 'platformId',
  organizationId: 'organizationId'
};

exports.Prisma.FilterScalarFieldEnum = {
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  id: 'id',
  userId: 'userId'
};

exports.Prisma.FilterPlatformOrPackageScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  filterId: 'filterId',
  platformId: 'platformId',
  platformPackageId: 'platformPackageId'
};

exports.Prisma.MediaOntologyGroupScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  label: 'label'
};

exports.Prisma.MediaOntologyItemScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  text: 'text',
  label: 'label',
  textEmbedding: 'textEmbedding',
  mediaOntologyGroupId: 'mediaOntologyGroupId'
};

exports.Prisma.ApiUserMonitoringRequestScalarFieldEnum = {
  createdAt: 'createdAt',
  id: 'id',
  apiCustomerId: 'apiCustomerId',
  apiPlanId: 'apiPlanId',
  username: 'username',
  platformId: 'platformId'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};
exports.BooleanMode = {
  And: 'And',
  Or: 'Or'
};

exports.SavedSearchPermission = {
  ReferenceAndView: 'ReferenceAndView'
};

exports.SavedSearchSubscriptionFrequency = {
  Daily: 'Daily',
  EveryThreeHours: 'EveryThreeHours',
  Immediately: 'Immediately',
  Monthly: 'Monthly',
  TwicePerDay: 'TwicePerDay',
  TwicePerWeek: 'TwicePerWeek',
  Weekly: 'Weekly'
};

exports.SavedSearchSubscriptionIncludedResultTypes = {
  All: 'All',
  HighlyHateful: 'HighlyHateful',
  HighlyOffensive: 'HighlyOffensive',
  HighlyViolent: 'HighlyViolent'
};

exports.ReportedPostContentType = {
  CSAM: 'CSAM'
};

exports.ReportedPostReviewStatus = {
  AwaitingReview: 'AwaitingReview',
  ReviewedOkay: 'ReviewedOkay',
  ReviewedCSAM: 'ReviewedCSAM'
};

exports.ApiPackage = {
  basic: 'basic',
  standard: 'standard',
  premium: 'premium'
};

exports.Prisma.ModelName = {
  DeletedItem: 'DeletedItem',
  User: 'User',
  Organization: 'Organization',
  SavedSearch: 'SavedSearch',
  SavedSearchUserLog: 'SavedSearchUserLog',
  GroupBlock: 'GroupBlock',
  TextBlock: 'TextBlock',
  UsernameBlock: 'UsernameBlock',
  StartsWithBlock: 'StartsWithBlock',
  SavedSearchBlock: 'SavedSearchBlock',
  SearchLog: 'SearchLog',
  UsernameSearchLog: 'UsernameSearchLog',
  SavedSearchSharedUsers: 'SavedSearchSharedUsers',
  SavedSearchSharedOrgs: 'SavedSearchSharedOrgs',
  SavedSearchNarrative: 'SavedSearchNarrative',
  SavedPost: 'SavedPost',
  QuickShareEmailAddresses: 'QuickShareEmailAddresses',
  SavedSearchSubscription: 'SavedSearchSubscription',
  ReportedPost: 'ReportedPost',
  ApiPlan: 'ApiPlan',
  ApiCustomer: 'ApiCustomer',
  ApiRequestLog: 'ApiRequestLog',
  Platform: 'Platform',
  PlatformPackage: 'PlatformPackage',
  OrganizationPlatformPackage: 'OrganizationPlatformPackage',
  OrganizationPlatform: 'OrganizationPlatform',
  Filter: 'Filter',
  FilterPlatformOrPackage: 'FilterPlatformOrPackage',
  MediaOntologyGroup: 'MediaOntologyGroup',
  MediaOntologyItem: 'MediaOntologyItem',
  ApiUserMonitoringRequest: 'ApiUserMonitoringRequest'
};

/**
 * Create the Client
 */
class PrismaClient {
  constructor() {
    throw new Error(
      `PrismaClient is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
    )
  }
}
exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
